(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEntityEmbeddedOneInput', drvEntityEmbeddedOneInput);

    /**
     * @ngdoc directive
     * @name drvEntityEmbeddedOneInput
     * @description One Embedded Entity input control.
     *
     * @param {object} value - An entity object which is an embedded entity
     * @param {array} entityTemplates - A list of entity templates for the tenant
     * @param {array} fieldTypes - A list of ChilliDocs field types
     * @param {object} field - Field settings for the input control
     * @param {array} fileAttachmentList - List of file attachments for the entity
     */
    function drvEntityEmbeddedOneInput() {
        return {
            templateUrl: 'app/fieldinput/entity-embedded-one-input.tmpl.html',
            require: 'ngModel',
            scope: {},
            controller: drvEntityEmbeddedOneInputCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                value: '=ngModel',
                entityTemplates: '=',
                fieldTypes: '=',
                field: '=',
                fileAttachmentList: '='
            }
        };
    }

    drvEntityEmbeddedOneInputCtrl.$inject = ['DialogService'];

    function drvEntityEmbeddedOneInputCtrl(DialogService) {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.editEmbeddedEntity = editEmbeddedEntity;
        Object.defineProperty(drvCtrl, 'entityTemplate', { get: function () { return _.find(drvCtrl.entityTemplates, function (entityTemplate) { return entityTemplate.Id === drvCtrl.field.EntityTemplateId; }); } });

        /**
         * For the embedded entity that the user clicked on, present a dialog to edit the entity.
         * If the user clicks 'OK' on the dialog, the embedded entity will be updated.
         */
        function editEmbeddedEntity(entity) {
            var enitityTemplate = angular.copy(drvCtrl.entityTemplate);
            var entityField = angular.copy(entity);
            var fieldTypes = angular.copy(drvCtrl.fieldTypes);
            var entityTemplates = angular.copy(drvCtrl.entityTemplates);

            DialogService.show({
                locals: { entityFields: entityField, entityTemplate: enitityTemplate, fieldTypes: fieldTypes, entityTemplates: entityTemplates, fileAttachmentList: drvCtrl.fileAttachmentList },
                controller: 'EntityEmbeddedEditCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/entity-embedded-edit.tmpl.html'
            })
            .then(editFieldOk);

            function editFieldOk(entityField, fileAttachmentList) {
                drvCtrl.value = entityField;
            }
        }
    }
})();